import { useAtom, useAtomValue } from "jotai";
import { cx } from "@/lib/cx";
import { DecoderResult } from "@/modules/plus/decoder/components/DecoderResult";
import { ModelList } from "@/modules/plus/models/components/ModelList";
import { atoms } from "@/state";

export const SearchView: React.FC = () => {
  const [text, setText] = useAtom(atoms.search.text);
  const decoded = useAtomValue(atoms.search.decoded);
  const showDecodedCard = useAtomValue(atoms.search.hasDecodedResult);
  const listCount = useAtomValue(atoms.models.filtered).length;

  return (
    <div className="mx-auto flex h-full max-w-4xl flex-col gap-5 px-6 py-8">
      <p className="text-sm text-gray-600 dark:text-gray-400">
        Paste a Nailor product code to decode it, or type to search the model database.
      </p>

      <input
        type="search"
        // biome-ignore lint/a11y/noAutofocus: kiosk UX — the search box is the whole page's purpose
        autoFocus
        autoComplete="off"
        spellCheck={false}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="e.g. 6500-O-9x9-24x24-L-AW-4A-SR08  or  pattern diffuser"
        className={cx(
          "rounded-lg border border-gray-300 bg-white px-3 py-2 font-mono text-sm shadow-sm",
          "dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-500",
          "focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500",
        )}
      />

      {showDecodedCard && (
        <section className="flex flex-col gap-2">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Decoded
          </h2>
          <DecoderResult result={decoded} />
        </section>
      )}

      <section className="flex min-h-0 flex-1 flex-col gap-2">
        <div className="flex items-baseline justify-between">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            {text.trim() ? "Matches" : "All models"}
          </h2>
          <span className="text-xs text-gray-500 dark:text-gray-400">
            {listCount.toLocaleString()} {listCount === 1 ? "model" : "models"}
          </span>
        </div>
        <ModelList />
      </section>
    </div>
  );
};
